import { Tooltip } from "react-tooltip";

interface ReactTooltipProps {
  id: string;
  content?: string;
  render?: () => React.ReactNode;
}

const ReactTooltip = ({ id, content, render }: ReactTooltipProps) => (
  <Tooltip
    id={id}
    place="bottom"
    variant="dark"
    {...(render ? { render } : { content })}
    className="!max-w-lg z-10"
    clickable
  />
);

export default ReactTooltip;
